module.exports = __webpack_public_path__ + "img/tech-15.39a5e3c4.jpg";